import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/archivo/wdth.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import setupAuthFetch from "./setupAuthFetch";
import { reindirizzaDaFirebase, rimuoviTokenVecchi } from "./auth/sessione";

// Minerva aperta da un indirizzo Firebase: si va su minerva.myetms.it prima di tutto.
const reindirizzato = reindirizzaDaFirebase();

// La sessione e' il cookie HttpOnly (condiviso dal browser tra le schede). Qui si
// tolgono i token delle versioni precedenti e, in una scheda nuova, si ricopia solo
// user_data (stato dell'interfaccia) prima del render, cosi' useAuth lo trova.
try {
  rimuoviTokenVecchi();
  if (!sessionStorage.getItem("user_data") && localStorage.getItem("user_data")) {
    sessionStorage.setItem("user_data", localStorage.getItem("user_data"));
  }
} catch (e) {
  // storage non disponibile (es. modalità privata restrittiva): si prosegue.
}

setupAuthFetch();

const root = ReactDOM.createRoot(document.getElementById('root'));
if (!reindirizzato) root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
